import { IXepHangHocSinhRequest } from '../models/request/xep-hang-hoc-sinh/IXepHangHocSinhSelectRequest';
import { IXepHangHocSinhUpdateRequest } from '../models/request/xep-hang-hoc-sinh/IXepHangHocSinhUpdateRequest';
import { IXepHangHocSinhSelectRequest } from './../models/request/xep-hang-hoc-sinh/IXepHangHocSinhRequest';
import { apiClient } from './apiClient';
export const xepHangHocSinhApi = {
    Select: (request: IXepHangHocSinhSelectRequest) => apiClient.post(`xep-hang/select`, request),
    SelectDiem: (request: IXepHangHocSinhSelectRequest) => apiClient.post(`xep-hang/diem/select`, request),
    XepHang: (request: IXepHangHocSinhRequest) => apiClient.post(`xep-hang`, request),
    UpdateKetQua: (request: IXepHangHocSinhUpdateRequest) => apiClient.put(`xep-hang`, request),
}